import { theme } from "../theme/theme";

import { JSX, ReactNode, Suspense } from "react";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import LinearProgress from "@mui/material/LinearProgress";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { RequestQuoteProvider } from "./context/RequestQuoteContext";

const customTheme = createTheme(theme);

interface MinimalAppContextProps {
  children: ReactNode;
}

const queryClient = new QueryClient();

//removes the vendor prefix on dev
const cacheNoPrefixer = createCache({
  key: "noprefixer",
  ...(process.env.NODE_ENV === "development" && { stylisPlugins: [] }),
});

export function MinimalAppContext(props: MinimalAppContextProps): JSX.Element {
  return (
    <ThemeProvider theme={customTheme}>
      <CacheProvider value={cacheNoPrefixer}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools />
          <RequestQuoteProvider>
            <CssBaseline />
            <Suspense fallback={<LinearProgress />}>{props.children}</Suspense>
          </RequestQuoteProvider>
        </QueryClientProvider>
      </CacheProvider>
    </ThemeProvider>
  );
}
